<template>
    <div class="page-tabs-box">
        <div class="title">
            <el-alert type="warning" effect="light" :closable="false">
                <div slot="title">
                    <slot></slot>
                </div>
            </el-alert>
        </div>
         <el-tabs v-model="activeName" @tab-click="clickEvent">
            <el-tab-pane
                label="基本信息"
                name="1"
                :link="`/user/site/edit/baseInfo/${id}`"
            ></el-tab-pane>
            
            <el-tab-pane
                v-if="$utils.have('/site/media')"
                label="相册管理"
                name="2"
                :link="`/user/site/edit/media/${id}`"
            ></el-tab-pane>
            <el-tab-pane
                v-if="$utils.have('/site/videoList')"
                label="视频管理"
                name="3"
                :link="`/user/site/edit/video/${id}`"
            ></el-tab-pane>
            <el-tab-pane
                v-if="$utils.have('/site/getliveRoom')"
                label="直播管理"
                name="4"
                :link="`/user/site/edit/live/${id}`"
            ></el-tab-pane>
            <el-tab-pane
                v-if="$utils.have('/site/accountInfo')"
                label="账号管理"
                name="5"
                :link="`/user/site/edit/account/${id}`"
            ></el-tab-pane>
            <el-tab-pane
                v-if="$utils.have('/site/userClaimInfo')"
                label="认证信息"
                name="6"
                :link="`/user/site/edit/auth/${id}`"
            ></el-tab-pane>
            <el-tab-pane
                v-if="$utils.have('/site/financeInfo')"
                label="财务信息"
                name="7"
                :link="`/user/site/edit/finance/${id}`"
            ></el-tab-pane>
			<el-tab-pane
			    v-if="$utils.have('/site/openService')"
			    label="开通服务"
			    name="8"
			    :link="`/user/site/edit/openservice/${id}`"
			></el-tab-pane>
           <!-- <el-tab-pane
                v-if="$utils.have('/site/seatInfo')"
			    label="场地座位图"
			    name="9"
			    :link="`/user/site/edit/seatMap/${id}`"
			></el-tab-pane> -->
         </el-tabs>
    </div>
</template>
<script>
export default {
    props: {
        name: {
            type: String,
            default: "1",
        },
    },
    data() {
        return {
            activeName: this.name,
            id: this.$route.params.id,
        };
    },
    methods: {
        clickEvent(tab) {
            if (tab.$attrs.link) this.$router.push(tab.$attrs.link);
        },
    },
};
</script>

<style lang="scss" scoped>
.title {
    font-size: 20px;
    margin: -20px -20px 10px -20px;
    .el-alert{
        border-radius: 0;
    }
}
.el-tabs {
    // margin-bottom: 10px;

    ::v-deep .el-tabs__header {
        margin-left: -20px;
        margin-right: -20px;
        .el-tabs__nav-wrap {
            padding: 0 20px;
            .el-tabs__item {
                font-size: 16px;
            }
        }
    }
}
</style>